import PropTypes, { element } from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import PhoneNumberComponent from '../components/PhoneNumberComponent';
import CardService from '../services/CardService';
import SettingService from '../services/SettingService';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';

class CardAuthorizeDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.settingService = new SettingService();
        this.state = {
            phoneNumber: props.phoneNumber,
            telephoneCodeOptions: [],
            accountRoleOptions: [
                {enumValue: 'DRIVER', label: props.t('AccountRole.DRIVER')},
                {enumValue: 'ADMIN', label: props.t('AccountRole.ADMIN')},
            ],
            accountRole: 'DRIVER',
            approvals: this.props.agreementsToAccept,
            acceptedTerms: {},
            
        };
        this.renderFooter = this.renderFooter.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.agreementsToAccept !== this.props.agreementsToAccept) {
            this.refreshApprovals();
        }
    }

    refreshApprovals() {
        this.setState({ approvals: this.props.agreementsToAccept });
    }

    initBeforeSetElement() {
        this.settingService
            .getTelephoneCodeList()
            .then((telephoneCodeOptions) => {
                if (this._isMounted) {
                    let phoneNumberCode, phoneNumberValue;
                    if (this.state.phoneNumber !== undefined && this.state.phoneNumber !== null && this.state.phoneNumber.startsWith('(')) {
                        let prefix = this.state.phoneNumber.substring(0, this.state.phoneNumber.indexOf(')') + 1);
                        if (prefix !== undefined) {
                            telephoneCodeOptions.forEach((element) => {
                                if (prefix === element.code) {
                                    phoneNumberCode = element;
                                    phoneNumberValue = this.state.phoneNumber.substring(this.state.phoneNumber.indexOf(')') + 1);
                                }
                            });
                        }
                    }
                    this.setState({
                        telephoneCodeOptions: telephoneCodeOptions,
                        phoneNumberCode,
                        phoneNumberValue,
                    });
                }
            })
            .catch(() => {});
    }

    getContainerListName() {
        return 'user-card-list-container';
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton
                    label={t('cards.authorizeCardHeader')}
                    variant='button save-button fullred'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`auth-dialog-header-label-id`}>{`${t('cards.authorizeCardHeader')}: ${this.props.cardNumber}`}</label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }
    setElement() {
        this.initAfterSetElement();
    }
    createOrUpdate() {
        const {t, cardNumber} = this.props;
        const {phoneNumberCode, phoneNumberValue, accountRole, acceptedTerms} = this.state;
        const acceptedApprovals = this.state.approvals.filter(a => acceptedTerms[a.approvalType] == true);
        const simplifyAcceptedApprovals = acceptedApprovals.map(({petraAgreementId, approvalType, accepted }) => ({petraAgreementId, approvalType,accepted}));

        let phoneNumber;
        if (
            phoneNumberCode !== undefined &&
            phoneNumberCode !== null &&
            phoneNumberValue !== undefined &&
            phoneNumberValue !== null &&
            phoneNumberValue !== ''
        ) {
            phoneNumber = phoneNumberCode.code + phoneNumberValue;
        }
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .authorizeCard(cardNumber, phoneNumber, accountRole, simplifyAcceptedApprovals)
                .then((response) => {
                    this.blockUi();
                    if (this.props.afterSave) {
                        this.persistMessage('success', '', t('cards.successAuthorize'));
                        this.props.afterSave();
                    }
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.afterSave) {
                        this.persistMessage('error', '', t('error.errorAuthorize'));
                        this.props.afterSave();
                    }
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        this.state.phoneNumberCode = this.state.phoneNumberCode === undefined ? this.state.telephoneCodeOptions[0] : this.state.phoneNumberCode;
        return (
            <div className='back-off-container'>
                <DivContainer colClass=''>
                    <span>{t('cards.authorizeCardBody')}</span>
                </DivContainer>
                <DivContainer colClass='back-off-row row'>
                    <PhoneNumberComponent
                        id='phoneNumber-dialog'
                        nameCode='phoneNumberCode'
                        namePhoneNumber='phoneNumberValue'
                        labelCode={t('cards.phoneNumberCode')}
                        labelPhoneNumber={t('cards.phoneNumber')}
                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                        phoneCodeValue={this.state.phoneNumberCode}
                        phoneNumberValue={this.state.phoneNumberValue}
                        telephoneCodeOptions={this.state.telephoneCodeOptions}
                        value={this.state.phoneNumber}
                        viewMode={this.props.viewMode}
                        onChange={this.handleChange}
                        validator={this.validator}
                        renderRequired
                        required
                        stateField=''
                    />
                    <InputDropdownComponent
                        id='accountRole-dialog'
                        name='accountRole'
                        label={t('cards.roleName')}
                        colClass='col-12 col-sm-5'
                        options={this.state.accountRoleOptions}
                        value={this.state.accountRole}
                        viewMode={this.props.viewMode}
                        onChange={this.handleChange}
                        validators='required'
                        validator={this.validator}
                        renderRequired
                        stateField=''
                        optionLabel='label'
                        enumMode
                        enumName='AccountRole'
                        optionValue='enumValue'
                        dataKey='enumValue'
                    />
                     <div className='row' style={{marginTop:'10px'}}>
                   {this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK' ? 
                   this.state.approvals?.map((approval, index) => {
                        const label = approval.contents
                            .map((str) => {
                                // return str.type === 'TRANSLATE'
                                //     ? t(`${str.content}`)
                                //     : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                                return str.type === 'TRANSLATE'
                                    ? str.content
                                    : `<a href="${str.linkUrl}" target="_blank">${str.linkLabel}</a> `;
                            })
                            .join('');
                        return (
                            <div>
                            <InputCheckboxComponent
                                id={`approval-${approval.approvalType}`}
                                key={`approval-${approval.approvalType}-${index}`}
                                name={`${approval.approvalType}`}
                                label={label}
                                labelOnRight
                                value={this.state.acceptedTerms[`${approval.approvalType}`]}
                                //value={approval.accepted}
                                onChange={(a,b,c,d,e)=> {
                                    this.handleChange(a,b,c,d,e)}}
                                stateField={`acceptedTerms`}
                                validator={this.validator}
                                viewMode='NEW'
                                colClass='col-12'
                                labelClassName='hybrid-approval-content-title'
                                required={!!approval.required}
                                renderRequired={!!approval.required}
                                validatorLabel=''
                                validators = {'required|checkbox_checked_required'}
                                onAfterStateChange={() => {}}
                                
                            />
                 
                            </div>
                            
                        );
                    }) : null} 
                   </div>

                </DivContainer>
            </div>
        );
    }
}

CardAuthorizeDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    cardNumber: '',
};

CardAuthorizeDialog.propTypes = {
    currentUser: PropTypes.object,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    phoneNumber: PropTypes.string,
    cardNumber: PropTypes.string,
    agreementsToAccept: PropTypes.array
};

export default withTranslation()(CardAuthorizeDialog);
